import React from "react";
import _ from "lodash";
import { Grid } from "semantic-ui-react";

import { Div } from "@components/Generics.react";
import LocationMenu from "@components/LocationMenu.react";
import Banner from "@components/Banner.react";
import TopicCard from "@components/TopicCard.react";
import CourseHeader from "./CourseHeader.react";
import { clientAssetsPath } from "@api/apiV6";

export default function FormalWrapper(props) {
    const {
        locData,
        setActiveLoc,
        activeLoc,
        course,
        showMenu,
        closeMenu,
        openDeck,
        courseHeader = true,
    } = props;
    const isPortrait = window.innerHeight > window.innerWidth;

    const hasCurrent =
        _.map(locData, "status").includes("current") || activeLoc;
    const locationArray = locData.map((thisLoc, locIndex) => {
        if (thisLoc != null) {
            return (
                <TopicCard
                    key={`topic-${locIndex}`}
                    locIndex={locIndex}
                    colors={course.colors}
                    topic={_.omit(thisLoc, "status")}
                    status={
                        (!hasCurrent && locIndex === 0) ||
                        activeLoc === locIndex
                            ? "lastopen"
                            : thisLoc.status
                    }
                    clickable={
                        !course.sequential || thisLoc.status !== "incomplete"
                    }
                    handleClick={setActiveLoc}
                />
            );
        } else {
            return <Div key={"location-" + locIndex} className="no-loc" />;
        }
    });
    const imageExtensions = ["png", "jpeg", "jpg"];
    const extension = course?.image?.split(".").pop().toLowerCase();
    const imageUrl = `${clientAssetsPath}/uploads/images/course/${course?._id}.${extension}`;
    const imageSrc = !imageExtensions.includes(extension)
        ? "/assets/images/configurable/missing.jpg"
        : imageUrl;

    // ========================= Render Function =================================
    return (
        <Div padded={!isPortrait}>
            {courseHeader && (
                <Grid stackable divided="vertically">
                    <Grid.Row>
                        <Grid.Column width={isPortrait ? 16 : 8}>
                            <CourseHeader course={course} compact />
                            {<Banner ads={[{ image: imageSrc }]} />}
                            <br />
                            <Div rounded noOverflow slightShadow>
                                {locationArray}
                            </Div>
                        </Grid.Column>
                        <Grid.Column width={8}></Grid.Column>
                    </Grid.Row>
                </Grid>
            )}
            {isPortrait && showMenu && <Div className="overlay loc-menu" />}
            <LocationMenu
                sequential={course.sequential}
                showMenu={!isPortrait || showMenu}
                content={locData[activeLoc]}
                openDeck={openDeck}
                closeMenu={isPortrait && closeMenu}
            />
        </Div>
    );
}
